import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/sleep-calculator',
  component: () => import('../../routes/SleepCalculator.svelte'),
  card: {
    id: 'sleep-calculator',
    title: 'Sleep Calculator',
    description: 'Find your optimal bedtime based on 90-minute sleep cycles. Wake up refreshed by timing your sleep to complete cycles.',
    icon: 'bedtime',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/sleep-calculator',
    category: 'Health & Fitness',
  },
  seo: {
    title: 'Sleep Calculator – Optimal Bedtime Based on Sleep Cycles',
    description:
      'Free sleep calculator to find your optimal bedtime. Uses 90-minute sleep cycles to help you wake up refreshed. Enter your wake time and get personalized bedtimes.',
  },
};

export default meta;
